module.exports = __webpack_public_path__ + "static/media/wallpaper5.9b7abe56.webp";